/**
 * @desc 新增冻结期订单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.FrozenCreateOrderDto, options?: any) {
  return updateResponse(
    http(URL + `/wms/frozenCreateOrder/add`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
